import { ReactNode } from "react";
import Modal, { Styles } from "react-modal";
import Close from "../icons/close";

const ContentModal = ({
	isOpen,
	closeModal,
	contentLabel,
	children,
	customStyles,
}: {
	isOpen: boolean;
	closeModal: () => void;
	contentLabel: string;
	children: ReactNode;
	customStyles?: Styles;
}) => {
	const styles = {
		...customStyles,
		overlay: { zIndex: 9999 },
	};
	return (
		<Modal
			isOpen={isOpen}
			onRequestClose={closeModal}
			contentLabel={contentLabel}
			style={styles}
			onAfterOpen={() => {
				document.body.style.top = `-${window.scrollY}px`;
				document.body.style.width = `100%`;
				document.body.style.position = "fixed";
			}}
			onAfterClose={() => {
				const scrollY = document.body.style.top;
				document.body.style.position = "";
				document.body.style.top = "";
				window.scrollTo(0, parseInt(scrollY || "0") * -1);
			}}
		>
			<button
				onClick={closeModal}
				className="absolute right-[2px] top-[2px] flex h-7 w-7 items-center justify-center rounded-sm border border-black bg-black p-2 text-white hover:bg-white hover:text-black focus:bg-white focus:text-black"
			>
				<Close />
			</button>
			{children}
		</Modal>
	);
};
export default ContentModal;
